module.exports = __webpack_public_path__ + "img/rat.f0cbd797.jpg";